import { cloneDeep, isEqual, forEach, find } from "lodash";

export class DetectChangesService {
    checkBoothPrintChange(newVal, oldVal, newLogo, oldLogo) {
        const newCloned = cloneDeep(JSON.parse(angular.toJson(newVal)));
        const oldCloned = cloneDeep(JSON.parse(angular.toJson(oldVal)));

        const newLogoCloned = cloneDeep(JSON.parse(angular.toJson(newLogo)));
        const oldLogoCloned = cloneDeep(JSON.parse(angular.toJson(oldLogo)));

        if (!isEqual(newLogoCloned, oldLogoCloned)) {
            return true;
        }

        if (newCloned.printingBackgroundMode !== oldCloned.printingBackgroundMode) {
            return true;
        }

        if (newCloned.printingBackgroundColor !== oldCloned.printingBackgroundColor) {
            return true;
        }

        if (!isEqual(newCloned.printingLogos, oldCloned.printingLogos)) {
            return true;
        }

        if (!isEqual(newCloned.printFile, oldCloned.printFile)) {
            return true;
        }

        if (!isEqual(newCloned.printingOverlayFiles, oldCloned.printingOverlayFiles)) {
            return true;
        }

        if (!isEqual(newCloned.printingBackgroundFiles, oldCloned.printingBackgroundFiles)) {
            return true;
        }

        return false;
    }

    checkBoothSharingChange(newVal, oldVal, newLogo, oldLogo) {
        const newCloned = cloneDeep(JSON.parse(angular.toJson(newVal)));
        const oldCloned = cloneDeep(JSON.parse(angular.toJson(oldVal)));

        const newLogoCloned = cloneDeep(JSON.parse(angular.toJson(newLogo)));
        const oldLogoCloned = cloneDeep(JSON.parse(angular.toJson(oldLogo)));

        if (!isEqual(newLogoCloned, oldLogoCloned) && newCloned.startScreenDesignSharing) {
            return true;
        }

        if (newCloned.startScreenDesignSharing !== oldCloned.startScreenDesignSharing) {
            return true;
        }

        if (newCloned.playbackSpeed && oldCloned.playbackSpeed && newCloned.playbackSpeed !== oldCloned.playbackSpeed) {
            return true;
        }

        if (newCloned.captureTime && oldCloned.captureTime && newCloned.captureTime !== oldCloned.captureTime) {
            return true;
        }

        if (newCloned.sharingBackgroundMode !== oldCloned.sharingBackgroundMode && newCloned.startScreenDesignSharing) {
            return true;
        }

        if (newCloned.sharingBackgroundColor !== oldCloned.sharingBackgroundColor && newCloned.startScreenDesignSharing) {
            return true;
        }

        if (!isEqual(newCloned.sharingLogos, oldCloned.sharingLogos) && newCloned.startScreenDesignSharing) {
            return true;
        }

        if (!isEqual(newCloned.sharingLogoAreas, oldCloned.sharingLogoAreas) && newCloned.startScreenDesignSharing) {
            return true;
        }

        if (!isEqual(newCloned.sharingFile, oldCloned.sharingFile)) {
            return true;
        }

        if (!isEqual(newCloned.sharingBackgroundFiles, oldCloned.sharingBackgroundFiles)) {
            return true;
        }

        if (!isEqual(newCloned.sharingOverlayFiles, oldCloned.sharingOverlayFiles)) {
            return true;
        }

        return false;
    }

    detectScenesChanges(newScenes, oldScenes) {
        if (!oldScenes || !oldScenes.scenesList || !oldScenes.scenesList.length) {
            return newScenes;
        }
        if (!newScenes || !newScenes.scenesList || !newScenes.scenesList.length) {

            return newScenes;
        }
        forEach(newScenes.scenesList, (s) => {
            let oldScene = find(oldScenes.scenesList, {timestamp: s.timestamp});
            delete s.updateScene;
            if (oldScene) {
                delete oldScene.updateScene;
            }
            if (!oldScene) {
                s.updateScene = true;
            } else {
                s.updateScene = !isEqual(s, oldScene);
            }
            if (s.updateScene) {
                console.log(`Scene "${s.title}" will be updated`);
            }
        });

        if (newScenes.scenesBtnTitleShow && (newScenes.sceneBtnTitle === undefined || newScenes.sceneBtnTitle.length < 1)){
            Object.assign(newScenes,{scenesBtnTitleShow: false,sceneBtnTitle:""});
        }

        return newScenes;
    }
}



// WEBPACK FOOTER //
// ./sources/services/configuration/detect-changes.js